module.exports = __webpack_public_path__ + "static/media/logo-stripe.0919b81b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-stripe.png
// module id = 416
// module chunks = 17